/* src/app/components/confirm-station-ops/confirm-station-ops.component.scss */
ion-content {
  --padding-bottom: 24px;
}
ion-footer {
  padding-bottom: calc(16px + max(env(safe-area-inset-bottom), var(--ion-safe-area-bottom, 0px), 24px));
}
ion-chip {
  --color: var(--ion-color-secondary);
  --background: var(--ion-color-tertiary);
}
.wallet-energy-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.wallet-energy-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--ion-color-primary);
}
.wallet-energy-label {
  font-size: 12px;
  color: #5f7180;
}
.benefits-description,
.benefits-note {
  font-size: 12px;
  color: #5f7180;
}
.benefits-note {
  margin-top: 8px;
  font-weight: 600;
}
.benefits-loading {
  --padding-start: 0;
  --inner-padding-end: 0;
  --background: transparent;
  color: #5f7180;
  font-size: 13px;
}
.sponsorship-list {
  display: grid;
  gap: 8px;
  margin-top: 10px;
}
.sponsorship-item {
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);
  border-radius: 8px;
  padding: 10px;
}
.sponsorship-item--primary {
  border-color: rgba(var(--ion-color-primary-rgb), 0.45);
}
.sponsorship-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.sponsorship-main {
  min-width: 0;
}
.sponsorship-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--ion-color-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sponsorship-status-icon {
  flex: 0 0 auto;
  font-size: 24px;
}
.sponsorship-coverage {
  margin-top: 8px;
}
.sponsorship-coverage-title {
  font-size: 12px;
  font-weight: 700;
  color: var(--ion-color-dark);
}
.sponsorship-coverage-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}
.sponsorship-coverage-list ion-chip {
  margin: 0;
}
.sponsorship-priority {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 600;
  color: var(--ion-color-primary);
}
.review {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.review__hero {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.review__eyebrow {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #5f7180;
}
.review__title {
  margin: 0;
  font-size: 23px;
  line-height: 1.14;
  font-weight: 750;
  letter-spacing: -0.01em;
  color: var(--ion-color-secondary);
  text-wrap: balance;
}
.review__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.review__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ion-color-secondary);
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.4);
  border-radius: 999px;
  padding: 5px 11px;
}
.review__chip-n {
  display: grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  margin-left: -3px;
  border-radius: 999px;
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  font-size: 11px;
  font-weight: 700;
}
.review__chip-mut {
  color: #5f7180;
  font-weight: 500;
}
.review__rule {
  height: 1px;
  background: rgba(var(--ion-color-medium-rgb), 0.28);
}
.review__label {
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #5f7180;
}
.review__tariff {
  font-size: 13.5px;
  line-height: 1.55;
  color: var(--ion-color-dark);
}
.review__cars ion-grid {
  padding: 0;
}
.review__cars ion-col {
  padding: 4px;
}
.review__add-vehicle {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
  padding: 13px;
  background: transparent;
  border: 1.5px dashed rgba(var(--ion-color-medium-rgb), 0.55);
  border-radius: 14px;
  color: var(--ion-color-primary);
  font-weight: 650;
  font-size: 13.5px;
  cursor: pointer;
}
.review__add-vehicle ion-icon {
  font-size: 18px;
}
.pay-method {
  margin-top: var(--yf-spacing3);
  display: flex;
  flex-direction: column;
  gap: var(--yf-spacing0);
}
.pay-option {
  display: flex;
  align-items: center;
  gap: var(--yf-spacing1);
  width: 100%;
  padding: var(--yf-spacing1);
  text-align: left;
  background: transparent;
  border: 1.5px solid rgba(var(--ion-color-medium-rgb), 0.4);
  border-radius: var(--yf-border-radius);
  color: var(--ion-color-dark);
  cursor: pointer;
}
.pay-option--on {
  border-color: var(--yf-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.07);
}
.pay-option[disabled] {
  opacity: 0.55;
}
.pay-option__i {
  flex: 0 0 auto;
  font-size: 22px;
  color: var(--yf-primary);
}
.pay-option__txt {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.pay-option__t {
  font-size: 14px;
  font-weight: 650;
  color: var(--ion-color-secondary);
}
.pay-option__s {
  font-size: 12px;
  color: #5f7180;
}
.pay-method__hint {
  margin: 0;
  font-size: 12.5px;
  color: var(--yf-primary-dark);
}
.review__stat {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.review__stat-k {
  font-size: 12.5px;
  color: #5f7180;
}
.review__stat-v {
  font-size: 20px;
  font-weight: 750;
  color: var(--ion-color-primary);
  font-variant-numeric: tabular-nums;
}
/*# sourceMappingURL=confirm-station-ops.component.css.map */
